import { render } from "./DigitalWalletDashboard.vue.js?vue&type=template&id=0cce062e!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./DigitalWalletDashboard.vue?vue&type=template&id=0cce062e"
import script from "./DigitalWalletDashboard.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./DigitalWalletDashboard.vue?vue&type=script&lang=js"
export * from "./DigitalWalletDashboard.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./DigitalWalletDashboard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Web/scripts/pages/digital-wallet/DigitalWalletDashboard.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0cce062e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0cce062e', __exports__)) {
    api.reload('0cce062e', __exports__)
  }
  
  module.hot.accept("./DigitalWalletDashboard.vue.js?vue&type=template&id=0cce062e!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./DigitalWalletDashboard.vue?vue&type=template&id=0cce062e", () => {
    api.rerender('0cce062e', render)
  })

}


export default __exports__